<!-- PRIMEIRA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="mostrarCampos">

    <!-- UNIDADE -->
    <div fxLayout="column" fxFlex="33%">
        <mat-toolbar class="titulopartes">Unidade</mat-toolbar>
        <mat-form-field>
            <mat-label>Unidade:</mat-label>
            <mat-select [(ngModel)]="atividade.unidade.idUnidade" name="unidade" required>
                <mat-option></mat-option>
                <mat-option *ngFor="let u of unidades" [value]="u.idUnidade">
                    {{u.nomeUnidade}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhuma unidade cadastrada</mat-hint>
        </mat-form-field>
    </div>


</div><!-- FIM PRIMEIRA LINHA -->





<!-- SEGUNDA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <!-- NOME DA OFICINA -->
    <div fxLayout="column" fxFlex="60%">
        <mat-toolbar class="titulopartes">Nome da Atividade</mat-toolbar>
        <mat-form-field>
            <input #descricao matInput maxlength="200" name="descricao" placeholder="Nome da Atividade:"
                [(ngModel)]="atividade.descricao" required>
            <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
        </mat-form-field>
    </div>

    <!-- PERIODO DE EXECUCAO -->
    <div fxLayout="column" fxFlex="39%">
        <mat-toolbar class="titulopartes">Período de Execução</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
            <mat-form-field style="margin-left: 20px" fxFlex="40%">
                <input matInput name="dataInicioExecucao" [matDatepicker]="dataInicioExecucao" placeholder="Data de Início:"
                    [(ngModel)]="atividade.dataInicio" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataInicioExecucao"></mat-datepicker-toggle>
                <mat-datepicker #dataInicioExecucao></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="40%">
                <input matInput name="dataFimExecucao" [matDatepicker]="dataFimExecucao" placeholder="Data Fim"
                    [(ngModel)]="atividade.dataFim" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataFimExecucao"></mat-datepicker-toggle>
                <mat-datepicker #dataFimExecucao></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div> <!-- FIM DA SEGUNDA LINHA -->

<!-- TERCEIRA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxLayout="column" fxFlex="50%">
        <mat-toolbar class="titulopartes">Informações</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
                          
            <mat-form-field fxFlex="33%">
                <input [ngModelOptions]="{standalone: true}" 
                    matInput [textMask]="{mask: mascaraHorario}" placeholder="Carga Horária"
                    type="text" [ngModel]="atividade.cargaHoraria | formatTimeHHMM"
                    (ngModelChange)="onTimeChange($event)">
            </mat-form-field>
              
            <mat-form-field fxFlex="33%">
                <input matInput type="number" name="quantidadeParticipantes" placeholder="Quantidade Participantes:"
                       [max]="999999" [(ngModel)]="atividade.quantidadeParticipantes">
            </mat-form-field>

            <mat-form-field fxFlex="33%">
                <input matInput type="number" name="maximoParticipantes" placeholder="Máximo Participantes:"
                       [(ngModel)]="atividade.maximoParticipantes">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="column" fxFlex="50%">
        <mat-toolbar class="titulopartes">Percurso</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
            <div ngModelGroup="comboContrato" fxLayoutGap="20px" fxFlex="100">
                <combo-percurso [showDisplayId]="false"
                                [obrigatorio]="false"
                                [selecionado]="atividade.percurso"
                                (valorChange)="onValorChangePercurso($event)">
                </combo-percurso>
            </div>
        </div>
    </div>
</div><!-- FIM DA TERCEIRA LINHA -->

<!-- QUARTA LINHA -->
<mat-toolbar class="titulopartes">Descrição</mat-toolbar>

<div fxLayout="row" fxLayoutGap="5%" style="margin-bottom: 20px">

    <mat-form-field class="topo" style="margin-left: 20px" fxFlex="100%" appearance="outline">
        <mat-label>Descrição:</mat-label>
        <textarea matInput #message name="metodologia" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3" maxlength="4000" [(ngModel)]="atividade.descricaoMetodologia">
             </textarea>
        <mat-hint align="end">{{message.value.length}} / 4000</mat-hint>
    </mat-form-field>

</div><!-- FIM DA QUARTA LINHA -->



<!-- QUINTA LINHA -->
<mat-toolbar class="titulopartes">Horários</mat-toolbar>
<div fxLayout="row" 
     fxLayoutGap="50px" 
     style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
        <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio"
            placeholder="Hora Início:" [(ngModel)]="atividade.horaInicio">
    </mat-form-field>

    <mat-form-field fxFlex="15%">
        <input matInput #horaFim="ngModel" mat-hide-icons="calendar" type="time" name="horaFim"
            placeholder="Hora Fim:" [(ngModel)]="atividade.horaFim">
    </mat-form-field>
    
    <div fxLayout="row" fxFlex="80%" 
         fxLayoutAlign="start center" fxLayoutGap="10px" class="topo"
         fxFlexFill>
        <mat-slide-toggle name="segunda" [(ngModel)]="atividade.segunda">SEG</mat-slide-toggle>
        <mat-slide-toggle name="terca" [(ngModel)]="atividade.terca">TER</mat-slide-toggle>
        <mat-slide-toggle name="quarta" [(ngModel)]="atividade.quarta">QUA</mat-slide-toggle>
        <mat-slide-toggle name="quinta" [(ngModel)]="atividade.quinta">QUI</mat-slide-toggle>
        <mat-slide-toggle name="sexta" [(ngModel)]="atividade.sexta">SEX</mat-slide-toggle>
        <mat-slide-toggle name="sabado" [(ngModel)]="atividade.sabado">SAB</mat-slide-toggle>
        <mat-slide-toggle name="domingo" [(ngModel)]="atividade.domingo">DOM</mat-slide-toggle>
    </div>

</div><!-- FIM QUINTA LINHA -->



<!-- DADOS BÁSICOS -->
<mat-toolbar class="titulopartes">Dados Básicos</mat-toolbar>
<div fxLayout="row" 
     fxLayoutAlign="space-between center" 
     style="margin-top: 10px; margin-bottom: 10px" 
     fxFlexFill>

            <!-- LOCAL EXECUÇÃO-->
            <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                <mat-label>Local de Execução:</mat-label>
                <mat-select [(ngModel)]="atividade.localExecucao" name="localExecucao">
                    <mat-option *ngFor="let u of localExecucao" [value]="u.id">
                        {{u.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
           
            <mat-form-field fxFlex="50%">
                <mat-label>Tipo de Atividade:</mat-label>
                <mat-select [(ngModel)]="atividade.tiposAtividades" name="tiposAtividades">
                    <mat-option *ngFor="let tipoAtividade of tiposAtividades" [value]="tipoAtividade">
                        {{tipoAtividade.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

</div>
<div ngModelGroup="acoesAtividade">
    <publico-alvo-atividade [oficina]="atividade"></publico-alvo-atividade>
</div>

<!-- OBJETIVOS DA ATIVIDADE -->
<!-- <mat-toolbar class="titulopartes">Objetivos</mat-toolbar> -->
<!-- <div fxLayout="row" fxFlexFill>
    <div fxFlex="100%" ngModelGroup="grupoObjetivoAtividade" style="margin-top: 10px; margin-bottom: 10px">
        <div *ngFor="let objetivoAtividade of atividade.objetivosAtividade; let index = index">
            <formulario-meta-objetivo [objetivoAtividade]="objetivoAtividade"
                                      [index]="index"
                                      [objetivosAtividade]="atividade.objetivosAtividade"
                                      [perfilAcesso]="perfilAcesso">
            </formulario-meta-objetivo>
        </div>
        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px"
             style="padding-top: 10px; padding-left: 20px;">
            <div>
                <button matTooltip="Novo Objetivo" mat-mini-fab color="primary" (click)="addObjetivoAtividade()"
                        style="width: 175px;border-radius: 5px;">
                    <mat-icon>add</mat-icon>
                    Objetivo Institucional
                </button>
            </div>
        </div>
    </div>
</div> -->